export const UNIT_SIZE = 40
export const MAX_COLUMNS = 15
export const MAX_ROWS = 15
export const MIN_COLUMNS = 3
export const MIN_ROWS = 3
